import React from 'react'
import Slider from 'react-slick'
import styled, { withTheme } from 'styled-components'

const Styles = styled.div`
  max-width: 1110px;
  margin: auto;

  .slick-list {
    max-height: 371px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .slick-prev {
    left: 3px;
    z-index: 1;
  }
  .slick-list {
    width: 100%;
  }
  .slick-next:before,
  .slick-prev:before {
    display: block;
    content: ' ';
    background-image: url('/img/arrow.svg');
    background-size: 28px 28px;
    height: 28px;
    width: 28px;
  }
  .slick-prev:before {
    transform: rotate(-180deg);
  }
  .slick-next {
    right: 15px;
  }
  .slick-dots {
    bottom: 20px;
  }
  @media (max-width: 400px) {
    .slick-next:before,
    .slick-prev:before {
      background-size: 14px 14px;
      height: 14px;
      width: 14px;
    }
  }
  @media (min-width: 1596px) and (max-width: 1700px) {
    width: 70vw;
  }
  @media (min-width: 1701px) {
    width: 1170px;
  }
`

class ImageSlider extends React.Component {

  forceUpdates = (imageIndex) => {
    const elements = document.getElementsByClassName(`image-carousel-${imageIndex}`)
    Array.prototype.forEach.call(elements, el => {
      if (!el.src.includes('.gif')) {
        return
      }
      el.src = `${el.getAttribute('data-src')}?m=${Math.random()}`
    })
  }

  images = () => {
    const { theme } = this.props
    const images = theme.getOption('home.homeCarousel')
    return images && images.map((item, index) => (
      <a key={index} target="_blank" rel="noopener noreferrer" href={item.link}>
        <img className={`image-carousel-${index}`} src={item.image} data-src={item.image} alt="" />
      </a>
    ))
  }

  render() {
    const { theme } = this.props
    const speed = theme.getOption('home.homeCarouselSpeed', 5000)

    const settings = {
      dots: true,
      infinite: true,
      /** Disable adaptive height, it is already responsive and this causes an extra top margin */
      adaptiveHeight: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: speed,
      autoplay: true,
      className: 'home-image-slider',
      beforeChange: (old, index) => {
        this.forceUpdates(index)
      }
    }

    return (
      <Styles>
        <Slider ref="slider" {...settings} {...this.props.settings}>
          {this.images()}
        </Slider>
      </Styles>
    )
  }
}

export default withTheme(ImageSlider)



// WEBPACK FOOTER //
// ./src/components/ImageSlider/index.js